import { Component } from "@angular/core";
import { LoaderService } from "src/app/services/loader.service";

@Component({
  selector: "app-loader-http",
  templateUrl: "./loader-http.component.html",
  styleUrls: ["./loader-http.component.scss"],
})
export class LoaderHttpComponent {
  loading: boolean;

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading.subscribe((r) => (this.loading = r));
  }
}
